import getMuiTheme from 'material-ui/styles/getMuiTheme';
import * as _colors from 'material-ui/styles/colors';
import { urlParam } from '../util/urlParam'

const muiTheme = getMuiTheme({
	palette: {
		primary1Color: urlParam(window.location.href).app === 'true' ? '#2F5A7C' : _colors.blue300,
		accent1Color: _colors.orange300
	}
});

export default muiTheme;


// WEBPACK FOOTER //
// ./src/components/ppappTheme.js